// extracted by mini-css-extract-plugin
export default {"commentsContainer":"PostCommentsModal_commentsContainer__VYNwN","modal":"PostCommentsModal_modal__G9v5O"};